import React, { useEffect, useState } from 'react';
import { replace, toLower, forEach, remove } from 'lodash-es';
import { getUrlParam, toBase64 } from '../util';
import { inputType } from '../constants';
import Input from './Input';
import ImagePicker from './ImagePicker';

function RegistrationDetails(props) {
	const { httpService } = props;

	const [data, setData] = useState({});
	const [files, setFiles] = useState([]);

	const {
		first_name,
		last_name,
		email,
		ime_tvrtke,
		natpis_izlagačkog_mjesta,
		web_stranica,
		kontakt_osoba,
		oib,
		kontakt_telefon,
		mjesto,
		adresa,
		poštanski_broj,
		onama,
		seat_nr,
	} = data;

	const handleInputChange = (event) => {
		const { id, value } = event.target;

		setData((prevData) => ({
			...prevData,
			[id]: value,
		}));
	};

	const onDropImage = (acceptedFiles) => {
		setFiles(
			acceptedFiles.map((file) =>
				Object.assign(file, {
					preview: URL.createObjectURL(file),
				}),
			),
		);
	};

	const onRemoveImage = (file) => {
		remove(files, (x) => x.preview == file.preview);
		setFiles(files.map((x) => Object.assign(x, { preview: x.preview })));
	};

	useEffect(() => {
		const fetchData = async () => {
			const bookingId = getUrlParam('bookingId');

			try {
				const bookingData = await httpService.getBookingByIdAsync(
					bookingId,
				);

				const { custom_field_data } = bookingData;

				const customData = transformCustomFields(
					JSON.parse(custom_field_data),
				);

				if (bookingData.logoBase64) {
					fetch(bookingData.logoBase64)
						.then((res) => res.blob())
						.then((blob) => {
							const file = new File([blob], 'File name', {
								type: 'image/png',
							});
							Object.assign(file, {
								preview: URL.createObjectURL(file),
							});

							setFiles([file]);
						});
				}

				setData({
					...bookingData,
					...customData,
				});
			} catch (err) {
				debugger;
			}
		};

		fetchData();
	}, []);

	const onSaveClicked = async (event) => {
		event.preventDefault();

		try {
			const payload = {
				...data,
				logoBase64: null,
			};

			if (files && files.length > 0) {
				if (files.length > 1) debugger;

				const logoBase64 = await toBase64(files[0]);
				payload.logoBase64 = logoBase64;
			}

			await httpService.putBookingAsync(
				getUrlParam('bookingId'),
				payload,
			);
		} catch (err) {
			debugger;
		}
	};

	return (
		<div className="register-form">
			<h2 className="form-title">Podaci o izlagaču</h2>
			{/* <p>
				Molimo vas da unesete podatke o izlagaču u cijelosti. Nakon
				provedene registracije emailom ćete dobiti link pomoću kojeg
				ćete moći urediti sekciju proizvoda koje izlažete i ostale
				podatke
			</p> */}
			<form onSubmit={onSaveClicked}>
				<div>
					<div style={{ marginBottom: '12px' }}>
						Broj izlagačkog mjesta: {seat_nr}
					</div>
					<div className="input-container-6-6">
						<Input
							id={'first_name'}
							type={inputType.text}
							label={'Naziv izlagača'}
							value={first_name}
							onChange={handleInputChange}
						/>
						<Input
							id={'natpis_izlagačkog_mjesta'}
							type={inputType.text}
							label={'Natpis Izlagačkog Mjesta'}
							value={natpis_izlagačkog_mjesta}
							onChange={handleInputChange}
						/>
					</div>
					<div className="input-container-8-4">
						<Input
							id={'ime_tvrtke'}
							type={inputType.text}
							label={'Ime tvrtke'}
							value={ime_tvrtke}
							onChange={handleInputChange}
						/>
						<Input
							id={'oib'}
							type={inputType.numeric}
							label={'OIB'}
							value={oib}
							onChange={handleInputChange}
						/>
					</div>
					<div></div>
					<div className="input-container-8-4">
						<Input
							id={'adresa'}
							type={inputType.text}
							label={'Adresa'}
							value={adresa}
							onChange={handleInputChange}
						/>
						<Input
							id={'poštanski_broj'}
							type={inputType.text}
							label={'Poštanski Broj'}
							value={poštanski_broj}
							onChange={handleInputChange}
						/>
						<Input
							id={'mjesto'}
							type={inputType.text}
							label={'Mjesto'}
							value={mjesto}
							onChange={handleInputChange}
						/>
					</div>
					<div className="input-container-6-6">
						<Input
							id={'last_name'}
							type={inputType.text}
							label={'Država'}
							value={last_name}
							onChange={handleInputChange}
						/>
					</div>
					{/* <div className="input-container-8-4"></div> */}
				</div>
				<div>
					<div className="input-container-6-6">
						<Input
							id={'kontakt_osoba'}
							type={inputType.text}
							label={'Kontakt Osoba'}
							value={kontakt_osoba}
							onChange={handleInputChange}
						/>
						<Input
							id={'kontakt_telefon'}
							type={inputType.numeric}
							label={'Telefon kontakt osobe'}
							value={kontakt_telefon}
							onChange={handleInputChange}
						/>
					</div>
				</div>
				<div className="input-container-6-6">
					<Input
						id={'email'}
						type={inputType.email}
						label={'Email kontakt osobe'}
						value={email}
						onChange={handleInputChange}
					/>
					<Input
						id={'web_stranica'}
						type={inputType.text}
						label={'Web stranica'}
						value={web_stranica}
						onChange={handleInputChange}
					/>
				</div>
				<div>
					<div>
						<Input
							id={'onama'}
							type={inputType.textarea}
							label={'O Nama'}
							value={onama}
							placeholder={'Max. 900 znakova'}
							onChange={handleInputChange}
							showCounter={true}
							maxLength={900}
							style={{ height: '200px' }}
						/>
					</div>
				</div>
				<div>
					<div>
						<label>Logo</label>
						<ImagePicker
							onDrop={onDropImage}
							onRemove={onRemoveImage}
							files={files}
						/>
					</div>
				</div>
				<p>
					Za sve upite nazvati:
					<br />
					099 385 7270 (Denis Despot)
				</p>
				<div>
					<button type="submit">Spremi</button>
				</div>
			</form>
		</div>
	);
}

function transformCustomFields(customFields) {
	const result = {};
	forEach(customFields, (x) => {
		const { label, value } = x;
		const key = replace(toLower(label), /\s/g, '_');

		result[key] = value;
	});
	return result;
}

export default RegistrationDetails;
